export default "__VITE_ASSET__B8vBgcQ6__"